export default __webpack_public_path__ + "img/instagram_hover.14b66cb2b111b09217f9671899335286.svg";